export default "__VITE_ASSET__DeAE8cb1__"